import React, {useState, useEffect} from "react";
import { useNavigate  } from "react-router-dom";
import { Helmet } from "react-helmet";
import {Header, Titulo, 
   // ContenedorHeader, ContenedorBotones
} from './../elementos/Header';
import BtnRegresar from "../elementos/BtnRegresar";
import FormularioEditaViaje from "./FormularioEditaViaje";
import FormularioViajePasajero from "./FormularioCreaViajePasajero";
import FormularioEditaViajePasajero from "./FormularioEditaViajePasajero";
import {ContenedorDoble} from '../elementos/ElementosDeFormularioCreaViaje';
import {useParams} from 'react-router-dom'
import useObtenerViajeId from './../hooks/useObtenerViajeId'
import useObtenerAdmin from '../hooks/useObtenerAdmin'
import { useAuth } from './../contextos/AuthContext';
import Swal from 'sweetalert2';
import {format, fromUnixTime} from 'date-fns';
import {es} from 'date-fns/locale';

const  EditarViaje = () => {
    const {id} = useParams();
    const [itinerario, cambiarItinerario] = useState([]); 
    const [fechaActualp, cambiarFechaActualP] = useState (new Date());
    const [listadoPasajeros, cambiarListadoPasajeros] = useState([]); 
    const [fechahoraviaje, cambiarFechahoraviaje] = useState (null);
    const [cliente, cambiarCliente] = useState ('Seleccione Cliente');
    const viaje = useObtenerViajeId({id});
    //console.log(viaje.itinerario)    
    const {usuario} = useAuth();
    const [TipoUsuario, cambiarTipoUsuario] = useState([]);
    const uid = usuario.uid
    const UsarioLog = useObtenerAdmin({uid});
    const [EditaPasajero, cambiarEditaPasajero] = useState(true);
    const [Escliente, cambiarEscliente] = useState(true);
    const [VerFormularioViaje, cambiarVerFormularioViaje] = useState(true);
    const [TelefoPasajeroEdit, CambiarTelefoPasajeroEdit] = useState('');
    const navigate = useNavigate();
    function toTimestamp(strDate){
        var datum = Date.parse(strDate);
        return datum;
     }

    useEffect (()=>{
   
        if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
          {cambiarTipoUsuario('admin')
          cambiarEscliente(false)
        }
        else
          {{cambiarTipoUsuario('cliente')}
        }
        if (Number(UsarioLog.numero) > 0)
        {cambiarTipoUsuario('conductor')
        cambiarEscliente(false)
      } 
      
    },[UsarioLog]);

    
    

    return ( 
        <>
        <Helmet>
        <title> Editar Viaje  </title>
        </Helmet>
            <Header>
                <BtnRegresar></BtnRegresar>
                <Titulo>Editar Viaje </Titulo>         
            </Header>
            <ContenedorDoble>
            <FormularioEditaViaje 
                cliente={cliente}
                cambiarCliente={cambiarCliente}
                id={id}
                viaje={viaje}
                itinerario={itinerario} 
                cambiarItinerario={cambiarItinerario} 
                listadoPasajeros={listadoPasajeros} 
                cambiarListadoPasajeros={cambiarListadoPasajeros} 
                cambiarVerFormularioViaje={cambiarVerFormularioViaje}
                Escliente={Escliente}
                UsarioLog={UsarioLog}
                cambiarEditaPasajero={cambiarEditaPasajero}
                EditaPasajero={EditaPasajero}
                CambiarTelefoPasajeroEdit={CambiarTelefoPasajeroEdit}
                TelefoPasajeroEdit={TelefoPasajeroEdit}
                fechahoraviaje={fechahoraviaje}
                cambiarFechahoraviaje={cambiarFechahoraviaje}
            >
            </FormularioEditaViaje>
            <div hidden={!EditaPasajero}>
            <FormularioViajePasajero
                cliente={cliente}
                cambiarCliente={cambiarCliente}
                itinerario={itinerario} 
                cambiarItinerario={cambiarItinerario} 
                listadoPasajeros={listadoPasajeros} 
                cambiarListadoPasajeros={cambiarListadoPasajeros} 
                fechahoraviaje={fechahoraviaje}
                cambiarFechahoraviaje={cambiarFechahoraviaje}
                cambiarVerFormularioViaje={cambiarVerFormularioViaje}
                CambiarTelefoPasajeroEdit={CambiarTelefoPasajeroEdit}
                Escliente={Escliente}
                UsarioLog={UsarioLog}
             >
             </FormularioViajePasajero>
             </div>
             <div hidden={EditaPasajero}>
            <FormularioEditaViajePasajero
                id={id}
                cliente={cliente}
                cambiarCliente={cambiarCliente}
                itinerario={itinerario} 
                cambiarItinerario={cambiarItinerario} 
                listadoPasajeros={listadoPasajeros} 
                cambiarListadoPasajeros={cambiarListadoPasajeros} 
                fechahoraviaje={fechahoraviaje}
                cambiarFechahoraviaje={cambiarFechahoraviaje}
                cambiarVerFormularioViaje={cambiarVerFormularioViaje}
                Escliente={Escliente}
                UsarioLog={UsarioLog}
                cambiarEditaPasajero={cambiarEditaPasajero}
                EditaPasajero={EditaPasajero}
                CambiarTelefoPasajeroEdit={CambiarTelefoPasajeroEdit}
                TelefoPasajeroEdit={TelefoPasajeroEdit}
             >
             </FormularioEditaViajePasajero>
             </div>
            </ContenedorDoble>
        
            

        
 
        </>

     );
}
 
export default  EditarViaje;